export class FileSharingAccountDTO{
    public id!: number;
    public customerId!: number;
    public type!: string; //i.e. "Dropbox"
    public accountEmail!: string; //i.e. Dropbox account email
    public folderPath!: string; //path in which to operator on
    public disabled!: boolean;
    public added!: string;
    public edited!: string;
}